<template>
  <div>
    Explanation:
    <div>
    <textarea v-model="exp" rows="5" class="w-100"></textarea>
    </div>
    <span class="badge badge-primary mr-2" v-if="openresult.choices !== undefined">
    {{openresult.choices[0].text}}
    </span>
    <span 
    v-if="loadingopenaing"
    class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary" 
    ></span>
    <span v-if="!loadingopenaing && textfound" class="card p-4 my-2">
    <h6>Text that has been parsed:</h6>
    {{textfound}}
    </span>
    <button class="btn btn-sm btn-primary"  v-if="!loadingopenaing" @click="checkOpenAi()">Open AI</button>
  </div>
</template>

<script>

import { openaiService } from "@/_services";


export default {  

  data () {
    return {
      loadingopenaing:false,
      textfound:'',
      openresult:false,
      exp: ""
    }
  },
  props: {
    email_id:String
  },



  methods: {
        removeTagsHTML(texto) {
          let div = document.createElement("div");
          div.innerHTML = texto;
          return div.textContent || div.innerText || "";
        },
        checkOpenAi(){
            this.loadingopenaing = true;
            openaiService.getSentiment(this.email_id,this.exp).then((result) => {
                this.openresult = result
                this.loadingopenaing = false;
                this.textfound = result.texto
            });
        },
  }
  }
</script>